import React from 'react';
import LoadingSpinner from '../../shared/LoadingSpinner';
import ImageCarousel from '../../shared/ImageCarousel';

const QuoteBuilderLayout = ({ images, loading, children }) => {
  return (
    <div className="card" style={{ margin: '10px' }} data-widget-element="layout-container">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <h3 style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px' }} data-widget-element="title">
            {t('quote_builder_widget.get_a_quote')}
          </h3>
          <div className="row">
            <div className="col-5" data-widget-element="image-column">
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ImageCarousel images={images} imageStyle={{ width: '100%', height: 'auto' }} />
              </div>
            </div>
            <div className="col-7" style={{ padding: '20px' }} data-widget-element="form-column">
              <div data-widget-element="form-section">
                {children}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default QuoteBuilderLayout;
